import { render, staticRenderFns } from "./all-routes.vue?vue&type=template&id=cec95a56&scoped=true"
import script from "./all-routes.vue?vue&type=script&lang=js"
export * from "./all-routes.vue?vue&type=script&lang=js"
import style0 from "./all-routes.vue?vue&type=style&index=0&id=cec95a56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec95a56",
  null
  
)

export default component.exports